import { computed } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { t } from '@/locales'

// Mirrors the tab labels in CustomersView.vue's own `navItems` — kept as a
// separate, lightweight list here rather than reusing that computed
// directly, since it also carries `isActive`/route-reactive state that's
// irrelevant to the page lookup palette. Gated by the same `customers.view`
// check useNavItems.ts uses for the generic "Customers" nav entry — these
// three entries supersede that one in the palette (see usePageLookupItems.ts),
// since bare "Customers" is a redirect shell with no page of its own.
// Update this alongside CustomersView.vue if these tabs change.
export function useCustomersTabs() {
  const userStore = useUserStore()

  return computed<{ label: string; routeName: string }[]>(() => {
    if (!userStore.canUser('customers.view')) return []
    return [
      { label: t('area.customer-account.tab.business'), routeName: 'CustomerAccountsList' },
      { label: t('W: Forsikring'), routeName: 'InsuranceCustomerAccountsList' },
      { label: t('area.customer-account.tab.private'), routeName: 'CustomerPrivateUsers' },
    ]
  })
}
